import {Component} from '@angular/core';
import {Http, Response} from '@angular/http';
import {Events, IonicPage, LoadingController, NavController, ToastController} from 'ionic-angular';

import {HelpPage} from '../help/help';
import {ProofTermsPage} from '../proof-terms/proof-terms';
import {NewSubscriptionStep1Page} from '../new-subscription-step1/new-subscription-step1';
import {QuizzAboutPage} from '../quizz-about/quizz-about';

import {AlertProvider} from '../../providers/alert/alert';
import {NetworkMonitorProvider} from '../../providers/network-monitor/network-monitor';
import {AuthProvider} from '../../providers/auth/auth';
import {ProofServerProvider} from '../../providers/proof-server/proof-server';
import {ProofProvider} from '../../providers/proof/proof';
import {SystemProvider} from '../../providers/system/system';
import {EventEmitterProvider} from '../../providers/event-emitter/event-emitter';
import {RegistrationProvider} from '../../providers/registration/registration';
import {QuizzServerProvider} from '../../providers/quizz-server/quizz-server';

import {SendingStatus} from '../../models/sendingstatus';

import * as Config from '../../app/app.config';
import {ChatbotProvider} from '../../providers/chatbot/chatbot';
import {WindowProtectorProvider} from '../../providers/window-protector/window-protector';

import {FullscreenProvider} from '../../providers/fullscreen/fullscreen';
import {ScreenDetailsProvider} from '../../providers/screen-details/screen-details';

/**
 * Generated class for the ProofListPage page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */
@IonicPage()
@Component({
  selector: 'page-proof-list',
  templateUrl: 'proof-list.html',
})
export class ProofListPage {

  hasSubscription: boolean;
  loading: boolean;
  private items: any = [];
  sending: any;
  private doUpdateSubscription: any;

  private canContractQuizz: boolean = false;
  private canContractQuizzSubscription: any;

  constructor(
    private http: Http,
    private navCtrl: NavController,
    private alertProvider: AlertProvider,
    private networkMonitor: NetworkMonitorProvider,
    private authProvider: AuthProvider,
    private loadingCtrl: LoadingController,
    private toastCtrl: ToastController,
    private proofServerProvider: ProofServerProvider,
    private proofProvider: ProofProvider,
    private systemProvider: SystemProvider,
    private events: Events,
    private eventEmitterProvider: EventEmitterProvider,
    private registrationProvider: RegistrationProvider,
    private quizzServerProvider: QuizzServerProvider,
    private chatbotProvider: ChatbotProvider,
    private windowProtectorProvider: WindowProtectorProvider,
    private fullScreenProvider: FullscreenProvider,
    private screenDetailsProvider: ScreenDetailsProvider,
  ) {
    this.loading = false;

    this.hasSubscription = this.authProvider.hasSubscription();

    this.networkMonitor.setCallback(null);
    this.networkMonitor.stop();

    this.prepareSendingStatus();

    // FIX: 2019-01-02 20:53 Francisco - Force update of proofs, because not a proof can be created after subscription released
    this.doUpdate(true);

    let that = this;
    this.doUpdateSubscription = this.eventEmitterProvider.get('do_update').subscribe(() => {
      that.doUpdate(true);
    });

    if (Config.quizzEnabled) {
      this.canContractQuizzSubscription = this.eventEmitterProvider.get('can_contract_quizz').subscribe((canContractQuizz: boolean) => {
        if ((canContractQuizz !== null) && (canContractQuizz !== undefined)) {
          that.canContractQuizz = canContractQuizz;
        } else {
          that.canContractQuizz = true;
        }
      });


      if (this.quizzServerProvider.getCanContractQuizz()) {
        this.canContractQuizz = true;
      }
    }
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad ProofListPage');
  }

  ionViewWillLeave() {
    this.doUpdateSubscription.unsubscribe();

    if (Config.quizzEnabled) {
      this.canContractQuizzSubscription.unsubscribe();
    }
  }

  public doUpdate(force: boolean = true) {
    let that = this;

    if (this.isAbleToContinue()) {

      if ((!this.sending.active) && (!this.loading)) {
        this.loading = true;

        this.prepareSendingStatus();

        let loader = this.loadingCtrl.create({
          content: 'Verificando...',
        });
        loader.present();

        this.items = [];
        if (this.authProvider.hasProofInOtherAccessKind()) {
          this.items.push({
            kind: 'hasProofInOtherAccessKind'
          });
        }

        this.authProvider.getProof(force).subscribe(data => {
          console.log('ProofListPage.doUpdate.Proof', data);

          if (Array.isArray(data)) {
            data = data[data.length - 1];
          }

          let proofPendingPayment = false;
          let headers = that.authProvider.createApplicationHeadersWithBearer();
          that.http.get(Config.baseUrl + '/subscriptions', {headers: headers}).map((res: Response) => res.json()).subscribe((subscriptions) => {

            for (var x = 0; x < subscriptions.length; x++) {
              if (subscriptions[x].paymentStatus === 'OPN') {
                proofPendingPayment = true;
                this.hasSubscription = true;
              }
            }

            /*
            if (!proofPendingPayment && data){
                  //TO DO VERIFICAR STATUS DE BLOQUEIO 'openProof'
                  that.items.push({
                    kind: 'do_proof',
                    proof: data
                  });
            } else
           */

            if (proofPendingPayment === true) {
              //TO DO VERIFICAR STATUS DE BLOQUEIO 'proofPendingPayment'
              that.items.push({
                kind: 'proofPendingPayment',
                proof: data
              });
            }
          });


          if (!data) {
            that.items.push({
              kind: 'unchecked',
              description: 'Não há prova disponível',
              value: -1
            });

            that.loading = false;
            loader.dismiss();
          } else {
            that.proofProvider.isFinished(data).subscribe((finished: boolean) => {
              if (finished) {

                that.alertProvider.doWaitingHide();

                // DONE: It is now automatically
                // that.items.push({
                //   kind: 'send_proof_answered',
                //   proof: data
                // });

                // DONE: It is now automatically
                that.sendProofAnswered(data.id);
              } else {

                let proofPendingPayment = false;
                let headers = that.authProvider.createApplicationHeadersWithBearer();
                that.http.get(Config.baseUrl + '/subscriptions', {headers: headers})
                  .map((res: Response) => res.json())
                  .subscribe((subscriptions) => {

                    for (var x = 0; x < subscriptions.length; x++) {
                      if ( /* subscriptions[x].proof.id === data.proofId && */ subscriptions[x].paymentStatus === 'OPN') {
                        proofPendingPayment = true;
                        console.log('proofPendingPayment: true');
                      }
                    }

                    if (Array.isArray(data)) {
                      data = data[data.length - 1];
                    }

                    if (!proofPendingPayment) {
                      //TO DO VERIFICAR STATUS DE BLOQUEIO 'openProof'
                      that.items.push({
                        kind: 'do_proof',
                        proof: data
                      });
                    } else {
                      //TO DO VERIFICAR STATUS DE BLOQUEIO 'proofPendingPayment'
                      that.items.push({
                        kind: 'proofPendingPayment',
                        proof: data
                      });
                    }
                  });
              }

              that.loading = false;
              loader.dismiss();
            }, (error: any) => {
              console.log(error);
              that.loading = false;
              loader.dismiss();
            });
          }
        }, (error: any) => {
          loader.dismiss();
          console.log('Não foi possível obter a prova.', error);

          let toast = this.toastCtrl.create({
            message: 'Não foi possível obter a prova.',
            duration: 3000,
            position: 'bottom'
          });
          toast.present();

          this.loading = false;
        });
      } else {
        let toast = this.toastCtrl.create({
          message: 'Não pode atualizar no momento. Aguarde um pouco e tente novamente.',
          duration: 3000,
          position: 'bottom'
        });
        toast.present();
      }

    }
  }

  async goToProofTermsPage(id: number) {
    let that = this;
    this.loading = true;

    this.chatbotProvider.hide();

    let loader = this.loadingCtrl.create({
      content: 'Obtendo detalhes...',
    });
    loader.present();

    const screenDetails = await this.screenDetailsProvider.getQuantity();
    console.log(screenDetails);
    localStorage.setItem('exams.screens', JSON.stringify(screenDetails));

    this.fullScreenProvider.requestFullscreen().then((): void => {
      // Do nothing.
    });

    this.proofServerProvider.fetch(id).subscribe(proof => {
      that.proofProvider.initiate(proof);
      that.loading = false;
      loader.dismiss();

      // that.events.subscribe('doProofUpdate', (paramsVar) => {
      //   console.log('ProofListPage.goToProofTermsPage.doUpdate', paramsVar);
      //   that.doUpdate(false);

      //   that.events.unsubscribe('doProofUpdate');
      // });
      that.events.subscribe('doProofUpdate', () => {
        console.log('ProofListPage.goToProofTermsPage.doUpdate');
        that.doUpdate(false);

        that.events.unsubscribe('doProofUpdate');
      });

      this.windowProtectorProvider.start();

      that.navCtrl.push(ProofTermsPage);
    }, (error: any) => {
      loader.dismiss();
      console.log('Não foi possível obter os detalhes da prova.', error);

      let toast = that.toastCtrl.create({
        message: 'Não foi possível obter os detalhes da prova.',
        duration: 3000,
        position: 'bottom'
      });
      toast.present();

      that.loading = false
      this.chatbotProvider.show();
    });
  }

  sendProofAnswered(id: number) {
    let that = this;

    if (!id) {
      id = this.proofProvider.getId();
    }

    if (!id) {
      this.alertProvider.doAlert('Não foi possível identificar a prova para envio. Tente novamente sem fechar esta página; se o erro persistir, acione o fiscal.', 'Aviso');
      return;
    }

    this.loading = true;

    this.alertProvider.doWaiting('Enviando...');
    this.prepareSendingStatus();

    this.proofServerProvider.send(id, this.sending,

      // onFinish
      (sendingStatus: any) => {
        that.loading = false;

        that.alertProvider.doWaitingHide();

        if (sendingStatus.done) {
          let message = 'Sua prova foi concluída com sucesso. Favor aguardar a divulgação do resultado.';

          that.alertProvider.doAlert(message, 'Aviso', () => {
            // that.systemProvider.close();
            // that.doUpdate(true);
            // Global
            that.eventEmitterProvider.get('do_update').emit();
          });
        } else if (sendingStatus.error) {
          let message = sendingStatus.errorMessage || 'Não foi possível concluir o envio da prova. Verifique sua conexão e tente novamente.';

          that.alertProvider.doAlert(message, 'Aviso');
        }
      });
  }

  private prepareSendingStatus() {
    this.sending = new SendingStatus();
  }

  askHelp() {
    this.navCtrl.push(HelpPage);
  }

  goToNewSubscription() {
    if (this.isAbleToContinue()) {
      this.navCtrl.push(NewSubscriptionStep1Page);
    }
  }

  private isAbleToContinue() {
    let ableToContinue = true;

    // // Verify if this registration is complete
    // if (!this.registrationProvider.isComplete()) {
    //   ableToContinue = false;
    //
    //   let that = this;
    //
    //   this.alertProvider.doAlert('Você precisa atualizar seu cadastro para poder continuar.', null, (): void => {
    //     that.navCtrl.setRoot(UpdateRegistrationPage);
    //     that.navCtrl.popToRoot({
    //       animation: 'ios-transition'
    //     });
    //   });
    // }

    return ableToContinue;
  }

  goToQuizzAboutPage() {
    this.navCtrl.setRoot(QuizzAboutPage);
    this.navCtrl.popToRoot({
      animation: 'ios-transition'
    });
  }

}



// WEBPACK FOOTER //
// ./src/pages/proof-list/proof-list.ts